import { HistoryBuffer } from "./HistoryBuffer";
export class Context {
    /**@type {Image} */
    origImg = new Image();
    /**@type {HTMLDivElement} */
    cnvDiv;
    /**@type {HTMLCanvasElement} */
    cnv;
    /**@type {CanvasRenderingContext2D} */
    cnvCtx;
    /**@type {HTMLCanvasElement} */
    offScrCnv;
    /**@type {CanvasRenderingContext2D} */
    offScrCnvCtx;
    /**@type {HTMLCanvasElement} */
    curCnv;
    /**@type {CanvasRenderingContext2D} */
    curCnvCtx;
    /**@type {HTMLCanvasElement} */
    tmpCnv;
    /**@type {CanvasRenderingContext2D} */
    tmpCnvCtx;
    /**@type {HTMLLabelElement} */
    viewLabelX;
    /**@type {HTMLLabelElement} */
    viewLabelY;
    /**@type {HTMLLabelElement} */
    imageLabelX;
    /**@type {HTMLLabelElement} */
    imageLabelY;
    /**@type {HTMLInputElement} */
    saveBtn;
    /**@type {HTMLInputElement} */
    loadBtn;
    /**@type {Number} */
    oldCnvWidth;
    /**@type {Number} */
    oldCnvHeight;
    HIST_SIZE = 6;
    /**@type {HistoryBuffer} */
    history = new HistoryBuffer(this.HIST_SIZE);
    imgW;
    imgH;
    offX = 0;
    offY = 0;
    curM;
    /**@type {Window} */
    globalObj;
    /**@type {Document} */
    document;
    MAX_SIZE = Math.pow(2, 14) - 1;
    #inited = false;
    listeners = {
        mousedown: null,
        mousemove: null,
        mouseup: null,
        mouseleave: null,
    };
    filename = null;
    resizeListener = null;
    static context = null;
    static getInstance() {
        if (this.context === null) {
            this.context = new Context();
        }
        return this.context;
    }
    bindCnvControls(params, resizeHandler) {
        this.unbindCnvControls();
        if (resizeHandler !== null) {
            this.resizeListener = resizeHandler;
            this.globalObj.addEventListener("resize", this.resizeListener);
        }
        for (let [key, val] of Object.entries(params)) {
            if (this.listeners[key] === null) {
                this.listeners[key] = params[key];
                this.cnv.addEventListener(key, params[key]);
            }
        }
    }
    unbindCnvControls() {
        this.globalObj.removeEventListener("resize", this.resizeListener);
        for (let [key, val] of Object.entries(this.listeners)) {
            this.cnv.removeEventListener(key, this.listeners[key]);
            this.listeners[key] = null;
        }
    }
    constructor() {}
    /**
     * @param {HTMLImageElement} origImg
     * @param {Window} globalObj
     */
    initAll(globalObj) {
        if (this.#inited) {
            return;
        }
        this.globalObj = globalObj;
        this.document = this.globalObj.document;
        // this.origImg = origImg;
        this.#initCanvases();
        this.oldCnvHeight = this.cnv.height;
        this.oldCnvWidth = this.cnv.width;
        this.offScrCnv.width = this.origImg.width;
        this.offScrCnv.height = this.origImg.height;
        this.offScrCnvCtx.drawImage(this.origImg, 0, 0);
        this.curM = this.cnvCtx.getTransform();
        // this.history = new Array();
        this.#initFooter();
        this.#initBtns();
        this.globalObj.addEventListener(
            "resize",
            this.#globalResizeHandler.bind(this)
        );
        this.#inited = true;
        this.origImg.addEventListener("load", () => {
            this.#reloadImg();
        });
        this.cnv.addEventListener("resize", this.#cnvResizeHandler.bind(this));
    }
    #cnvResizeHandler() {}
    #globalResizeHandler() {
        this.updateImage();
    }
    #initBtns() {
        this.saveBtn = this.document.querySelector("#save-btn");
        this.loadBtn = this.document.querySelector("#load-btn");
        this.resetBtn = this.document.querySelector("#reset-img-btn");
        this.undoBtn = this.document.querySelector("#undo-btn");
        this.redoBtn = this.document.querySelector("#redo-btn");

        this.saveBtn.addEventListener("click", this.#saveHandler.bind(this));
        this.loadBtn.addEventListener("change", this.#loadHandler.bind(this));
        this.resetBtn.addEventListener("click", this.#reloadImg.bind(this));
        this.undoBtn.addEventListener("click", this.undo.bind(this));
        this.redoBtn.addEventListener("click", this.redo.bind(this));
    }
    #saveHandler(e) {
        const link = this.document.createElement("a");
        const now = new Date();
        const old_fname = this.filename ? this.filename : 'unnamed';
        const filename = `${now.toISOString()}__${old_fname}_dmi.png`
        link.download = filename;
        link.href = this.offScrCnv.toDataURL("image/png", 1);
        link.click();
        link.delete;
    }
    #loadHandler(event) {
        console.log("load fired");
        let file = this.loadBtn.files[0];
        let reader = new FileReader();
        reader.onload = function () {
            this.origImg.src = reader.result;
        }.bind(this);
        if (file) {
            reader.readAsDataURL(file);
        } else {
            console.log("File is " + file);
        }
    }
    #reloadImg() {
        this.offScrCnv.width = this.origImg.width;
        this.offScrCnv.height = this.origImg.height;
        this.offScrCnvCtx.clearRect(
            0,
            0,
            this.offScrCnv.width,
            this.offScrCnv.height
        );
        this.offScrCnvCtx.drawImage(this.origImg, 0, 0);
        this.updateImage();
        this.history = new HistoryBuffer(this.HIST_SIZE);
        this.putToHistory();
    }
    replaceImg(newImg) {
        this.origImg.src = newImg;
        this.origImg.addEventListener(
            "load",
            function tmp() {
                this.#reloadImg();
                // this.history = new HistoryBuffer(this.HIST_SIZE);
                // this.putToHistory();
                this.origImg.removeEventListener("load", tmp);
            }.bind(this)
        );
    }
    #initCanvases() {
        this.cnvDiv = this.document.querySelector(".work-canvas");
        this.cnv = this.document.querySelector("#img-editor-view-canvas");
        this.cnvCtx = this.cnv.getContext("2d");
        this.offScrCnv = this.document.createElement("canvas");
        this.offScrCnvCtx = this.offScrCnv.getContext("2d");
        this.curCnv = this.document.createElement("canvas");
        this.curCnvCtx = this.curCnv.getContext("2d");
        this.tmpCnv = this.document.createElement("canvas");
        this.tmpCnvCtx = this.tmpCnv.getContext("2d", {
            willReadFrequently: true,
        });
    }
    #initFooter() {
        this.viewLabelX = this.document.querySelector("#view-x");
        this.viewLabelY = this.document.querySelector("#view-y");
        this.imageLabelX = this.document.querySelector("#image-x");
        this.imageLabelY = this.document.querySelector("#image-y");

        this.cnv.addEventListener("mousemove", this.#footerUpdate.bind(this));
    }
    putToHistory(cnv = null) {
        let workCnv = this.offScrCnv;
        if (cnv !== null) {
            workCnv = cnv;
        }
        let workCnvCtx = workCnv.getContext("2d");
        let w = workCnv.width;
        let h = workCnv.height;
        let imgData = workCnvCtx?.getImageData(0, 0, w, h);
        this.history.push(imgData);
    }
    undo() {
        let imgData = this.history.undo();
        if (imgData === null) {
            console.log("Nothing left in history");
            return;
        }
        this.offScrCnv.width = imgData.width;
        this.offScrCnv.height = imgData.height;
        this.offScrCnvCtx.putImageData(imgData, 0, 0);
        this.updateImage();
    }
    redo() {
        let imgData = this.history.redo();
        if (imgData === null) {
            console.log("Nothing left in history");
            return;
        }
        this.offScrCnv.width = imgData.width;
        this.offScrCnv.height = imgData.height;
        this.offScrCnvCtx.putImageData(imgData, 0, 0);
        this.updateImage();
    }
    updateImage(argCnv = null, keepScale = false) {
        let oldTr = this.cnvCtx.getTransform();
        this.cnv.width = this.cnvDiv.clientWidth;
        this.cnv.height = this.cnvDiv.clientHeight;
        let workCnv = this.offScrCnv;
        let oldSX = oldTr.a,
            oldSY = oldTr.d;

        if (argCnv !== null) {
            workCnv = argCnv;
        }
        if (workCnv.width == 0 || workCnv.height == 0) {
            return;
        }
        let k = workCnv.height / workCnv.width;

        let viz_k = this.cnv.clientHeight / this.cnv.clientWidth;
        if (!keepScale) {
            if (k > viz_k) {
                //Image occupies all height
                this.imgH = this.cnv.clientHeight;
                this.imgW = this.imgH / k;
                this.offX = Math.round(
                    this.cnv.clientWidth / 2 - this.imgW / 2
                );
                this.offY = 0;
            } else {
                //Image occupies all width
                this.imgW = this.cnv.clientWidth;
                this.imgH = k * this.imgW;
                this.offY = Math.round(
                    this.cnv.clientHeight / 2 - this.imgH / 2
                );
                this.offX = 0;
            }
        }
        let vizScaleX = workCnv.width / this.imgW;
        let vizScaleY = workCnv.height / this.imgH;

        this.curCnv.width = workCnv.width;
        this.curCnv.height = workCnv.height;
        this.curCnvCtx.drawImage(workCnv, 0, 0);
        this.cnvCtx.transform(
            this.curM.a,
            this.curM.b,
            this.curM.c,
            this.curM.d,
            this.curM.e,
            this.curM.f
        );
        if (keepScale) {
            this.cnvCtx.scale(oldSX, oldSY);
            let newTr = this.cnvCtx.getTransform();
            let newSX = newTr.a,
                newSY = newTr.d;
            let newW = Math.round(workCnv.width * newSX),
                newH = Math.round(workCnv.height * newSY);
            let newOffX =
                Math.round(this.cnv.clientWidth / 2 - newW / 2) * (1 / newSX);
            let newOffY =
                Math.round(this.cnv.clientHeight / 2 - newH / 2) * (1 / newSY);
            // let newOffX = Math.round(this.cnv.clientWidth / 2 - this.imgW / 2);
            // let newOffY = Math.round(this.cnv.clientHeight / 2 - this.imgH / 2);
            this.cnvCtx.translate(newOffX, newOffY);
            this.offX = Math.round(newOffX * newSX);
            this.offY = Math.round(newOffY * newSY);
            this.imgW = newW;
            this.imgH = newH;
        } else {
            this.cnvCtx.translate(this.offX, this.offY);
            this.cnvCtx.scale(1 / vizScaleX, 1 / vizScaleY);
        }
        this.cnvCtx.drawImage(this.curCnv, 0, 0);
    }
    viewToOr(pt) {
        let workCnv = this.offScrCnv;
        let newPt = [0, 0];
        let kX = workCnv.width / this.imgW;
        let kY = workCnv.height / this.imgH;
        newPt[0] = Math.round((pt[0] - this.offX) * kX);
        newPt[1] = Math.round((pt[1] - this.offY) * kY);
        return newPt;
    }
    orToView(pt) {
        let workCnv = this.offScrCnv;

        let newPt = [0, 0];
        let kX = workCnv.width / this.imgW;
        let kY = workCnv.height / this.imgH;
        newPt[0] = Math.round(pt[0] / kX) + this.offX;
        newPt[1] = Math.round(pt[1] / kY) + this.offY;
        return newPt;
    }
    canvasToView(pt, canvas) {
        let newPt = [0, 0];
        let kX = canvas.width / this.imgW;
        let kY = canvas.height / this.imgH;
        newPt[0] = Math.round(pt[0] / kX) + this.offX;
        newPt[1] = Math.round(pt[1] / kY) + this.offY;
        return newPt;
    }

    #footerUpdate(event) {
        let orPt = this.viewToOr([event.offsetX, event.offsetY]);
        this.viewLabelX.innerHTML = " View X: " + event.offsetX;
        this.viewLabelY.innerHTML = " View Y: " + event.offsetY;
        this.imageLabelX.innerHTML = " Координата X: " + orPt[0];
        this.imageLabelY.innerHTML = " Координата Y: " + orPt[1];
    }
}
